/**
 * Mock sessiya almashtirgich (/dev/session) qachon mavjud: Vite dev rejimida
 * yoki build vaqtida VITE_DEV_SESSION=true berilganda (lokal Docker stack).
 * Backend `ENVIRONMENT=local` bo'lmasa cookie baribir ishlamaydi.
 */
export const DEV_SESSION_ENABLED =
  import.meta.env.DEV || import.meta.env.VITE_DEV_SESSION === 'true';
